// 文章8数据信息
export default {
  id: 'dayunshan_108',
  content: `# 天然的 “酸菜”—— 荞麦叶：解锁 N 种神仙吃法
  ![天然的 “酸菜”—— 荞麦叶：解锁 N 种神仙吃法1](https://cdn.keihong.tech/img/20250518213926186.jpg)
![天然的 “酸菜”—— 荞麦叶：解锁 N 种神仙吃法3](https://cdn.keihong.tech/img/20250518213932136.jpg)
![天然的 “酸菜”—— 荞麦叶：解锁 N 种神仙吃法4](https://cdn.keihong.tech/img/20250518213935402.jpg)
![天然的 “酸菜”—— 荞麦叶：解锁 N 种神仙吃法5](https://cdn.keihong.tech/img/20250518213938355.jpg)
![天然的 “酸菜”—— 荞麦叶：解锁 N 种神仙吃法6](https://cdn.keihong.tech/img/20250518213941039.jpg)
![天然的 “酸菜”—— 荞麦叶：解锁 N 种神仙吃法7](https://cdn.keihong.tech/img/20250518213943898.jpg)`
}
